import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const phoneNumber = '16132959098'; // Format: country code + number without special chars
  const message = encodeURIComponent('Hi! I\'m interested in learning more about your renovation services.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="relative">
          {/* Tooltip */}
          {showTooltip && (
            <div className="absolute bottom-full right-0 mb-3 w-48 bg-white rounded-lg shadow-xl p-3 border border-[rgba(0,0,0,0.1)]">
              <button
                onClick={() => setShowTooltip(false)}
                className="absolute top-2 right-2 text-[rgb(175,183,180)] hover:text-[rgb(0,55,32)]"
              >
                <X className="w-3 h-3" />
              </button>
              <p className="text-sm text-[rgb(0,55,32)] font-semibold mb-1">
                Need quick help?
              </p>
              <p className="text-xs text-[rgb(131,146,140)] mb-2">
                Chat with us on WhatsApp for instant answers!
              </p>
            </div>
          )}
          
          {/* Main Button */}
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            className="flex items-center justify-center w-16 h-16 bg-[#25D366] rounded-full shadow-lg hover:shadow-2xl transition-all hover:scale-110 group"
            aria-label="Contact us on WhatsApp"
          >
            <MessageCircle className="w-8 h-8 text-white" />
            
            {/* Pulse animation */}
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></span>
          </a>
        </div>
      </div>
    </>
  );
};

export default WhatsAppButton;
